import { createSvgIcon } from '@material-ui/core';

export const UserIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 24C28.1421 24 31.5 20.6421 31.5 16.5C31.5 12.3579 28.1421 9 24 9C19.8579 9 16.5 12.3579 16.5 16.5C16.5 20.6421 19.8579 24 24 24ZM20.5385 27.4615C14.1659 27.4615 9 32.6275 9 39H39C39 32.6275 33.8341 27.4615 27.4615 27.4615H20.5385Z"
      fill="currentColor"
    />
  </svg>,
  'UserIcon',
);
